import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DicomViewer from 'components/DicomViewer';
import { standardizeHttpsUrl } from 'components/DicomViewer/utils';

const propTypes = {
  dicomFilePaths: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
};

const ViewerViewport = ({ dicomFilePaths }) => {
  const imageIds = dicomFilePaths.map((filePath) => {
    return standardizeHttpsUrl(filePath);
  });

  return (
    <Fragment>
      <DicomViewer images={imageIds} hideToolBar={true} />
    </Fragment>
  );
};

ViewerViewport.propTypes = propTypes;

export default ViewerViewport;
